import React from 'react'
import { Link, Switch, Route } from 'react-router-dom'

import { ROUTE_NAME } from '../constants'

import IncidentTypeBuffers from '../incidentType/components/Index'
import DivisionBuffers from '../division/components/Index'
import CategoryBuffers from '../category/components/Index'
import UserBuffers from '../user/components/Index'

import styles from './Index.module.css'

const BufferIndex = () => (
  <div className={styles.container}>
    <Link className={styles.link} to={`/admin/${ROUTE_NAME}/incidentType`}>
      Incident Type Buffers
    </Link>
    <Link className={styles.link} to={`/admin/${ROUTE_NAME}/category`}>
      Incident Category Buffers
    </Link>
    <Link className={styles.link} to={`/admin/${ROUTE_NAME}/division`}>
      Incident Division Buffers
    </Link>
    <Link className={styles.link} to={`/admin/${ROUTE_NAME}/user`}>
      User Defined Buffers
    </Link>
  </div>
)

const Index = () => (
  <Switch>
    <Route
      path={`/admin/${ROUTE_NAME}/incidentType`}
      component={IncidentTypeBuffers}
    />
    <Route path={`/admin/${ROUTE_NAME}/category`} component={CategoryBuffers} />
    <Route path={`/admin/${ROUTE_NAME}/division`} component={DivisionBuffers} />
    <Route path={`/admin/${ROUTE_NAME}/user`} component={UserBuffers} />
    <Route component={BufferIndex} />
  </Switch>
)

export default Index
